import { useState, type FormEvent } from 'react';
import { useAuth } from './auth';
import { ApiRequestError } from './api';

export function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(username.trim(), password);
    } catch (err) {
      setError(
        err instanceof ApiRequestError ? err.message : '로그인에 실패했습니다.',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-surface px-6">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-3xl bg-card p-7 shadow-soft"
      >
        <div className="mb-6 flex flex-col items-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-surface-soft text-3xl">
            🐱
          </div>
        </div>

        <label className="mb-3 block">
          <span className="mb-1 block text-sm text-ink-soft">아이디</span>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoCapitalize="none"
            autoComplete="username"
            className="w-full rounded-2xl border border-line bg-surface px-4 py-3 text-ink outline-none focus:border-accentA"
          />
        </label>
        <label className="mb-4 block">
          <span className="mb-1 block text-sm text-ink-soft">비밀번호</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            className="w-full rounded-2xl border border-line bg-surface px-4 py-3 text-ink outline-none focus:border-accentA"
          />
        </label>

        {error && (
          <p className="mb-3 rounded-xl bg-accentA/10 px-3 py-2 text-sm text-accentA">{error}</p>
        )}

        <button
          type="submit"
          disabled={busy || !username || !password}
          className="w-full rounded-2xl bg-accentA py-3 font-semibold text-white shadow-card tap-bounce disabled:opacity-50"
        >
          {busy ? '확인 중…' : '로그인'}
        </button>
      </form>
    </div>
  );
}
